export default "__VITE_ASSET__BNWbJIFV__"